export default class DetailCarUserRequest
{
    constructor(
        
        public carUserID: number  
    ) {
    }
}
